// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerBody":"Footer_footerBody__6FfJJ","footerBody__link":"Footer_footerBody__link__Gkpd9"};